// LOP - PDP Style ID: switch sibling color products without full page reload
(function () {
  'use strict';

  var enabled = window.theme && window.theme.settings && window.theme.settings.enable_related_by_style;
  if (!enabled) return;
  if (!document.body.classList.contains('template-product')) return;

  var PRODUCT_SEL = '.product[data-section-type="product"][data-is-full-product="true"]';
  var SWATCH_SEL = '[data-lop-pdp-style-swatch]';
  var LOADING_CLASS = 'product-related-by-style--loading';
  var isLoading = false;

  function getProductSection() {
    return document.querySelector(PRODUCT_SEL);
  }

  function handleFromPath(path) {
    var match = (path || window.location.pathname).match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function productsRoot() {
    var root = window.theme && window.theme.routes && window.theme.routes.products;
    return root || '/products';
  }

  function buildSectionRequestUrl(handle, sectionId) {
    var base = productsRoot();
    if (base.charAt(base.length - 1) === '/') {
      base = base.slice(0, -1);
    }
    return base + '/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(sectionId);
  }

  function unloadSectionContainer(container) {
    var sectionsApi = window.Shopify && window.Shopify.theme && window.Shopify.theme.sections;
    if (!sectionsApi || !sectionsApi.instances) return;

    for (var i = sectionsApi.instances.length - 1; i >= 0; i--) {
      if (sectionsApi.instances[i].container === container) {
        sectionsApi.instances[i].onUnload();
        sectionsApi.instances.splice(i, 1);
        break;
      }
    }
  }

  function extractProductNode(html, sectionId) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var wrapper = doc.getElementById('shopify-section-' + sectionId);
    if (wrapper) {
      return (
        wrapper.querySelector('[data-section-type="product"][data-is-full-product="true"]') ||
        wrapper.querySelector('[data-section-type="product"]')
      );
    }
    return doc.querySelector('[data-section-type="product"][data-is-full-product="true"]');
  }

  function setLoading(active) {
    var blocks = document.querySelectorAll('[data-lop-pdp-style-switch]');
    blocks.forEach(function (block) {
      block.classList.toggle(LOADING_CLASS, active);
    });
  }

  function updateDocumentTitle(handle) {
    var base = productsRoot();
    if (base.charAt(base.length - 1) === '/') {
      base = base.slice(0, -1);
    }
    fetch(base + '/' + encodeURIComponent(handle) + '.js')
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (product) {
        if (!product || !product.title) return;
        var shopName = window.theme && window.theme.strings && window.theme.strings.name;
        document.title = shopName ? product.title + ' \u2013 ' + shopName : product.title;
      })
      .catch(function () {});
  }

  function reloadSectionInstance(container, sectionId) {
    var sectionsApi = window.Shopify && window.Shopify.theme && window.Shopify.theme.sections;
    if (sectionsApi && typeof sectionsApi.loadSection === 'function') {
      sectionsApi.loadSection('product', container);
    }

    var wrapper = document.getElementById('shopify-section-' + sectionId) || container.parentElement;
    if (wrapper) {
      wrapper.dispatchEvent(
        new CustomEvent('shopify:section:load', {
          bubbles: true,
          detail: { sectionId: sectionId },
        })
      );
    }
  }

  function switchToProduct(handle, productUrl, options) {
    var opts = options || {};
    if (!handle || isLoading) return Promise.resolve();

    var currentSection = getProductSection();
    if (!currentSection) return Promise.resolve();

    var sectionId = currentSection.getAttribute('data-section-id');
    if (!sectionId) return Promise.resolve();

    if (handle === currentSection.getAttribute('data-product-handle')) {
      return Promise.resolve();
    }

    isLoading = true;
    setLoading(true);

    return fetch(buildSectionRequestUrl(handle, sectionId))
      .then(function (res) {
        if (!res.ok) throw new Error('Section request failed');
        return res.text();
      })
      .then(function (html) {
        var nextSection = extractProductNode(html, sectionId);
        if (!nextSection) throw new Error('Product section markup missing');

        unloadSectionContainer(currentSection);
        currentSection.outerHTML = nextSection.outerHTML;

        var mounted = getProductSection();
        if (!mounted) throw new Error('Product section mount failed');

        reloadSectionInstance(mounted, sectionId);

        if (opts.updateHistory !== false && productUrl) {
          history.pushState({ lopStyleSwitch: true, handle: handle }, '', productUrl);
        }

        updateDocumentTitle(handle);

        var top = mounted.getBoundingClientRect().top + window.pageYOffset - 24;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      })
      .catch(function () {
        if (productUrl) {
          window.location.assign(productUrl);
        }
      })
      .finally(function () {
        isLoading = false;
        setLoading(false);
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      var swatch = event.target.closest(SWATCH_SEL);
      if (!swatch) return;

      var handle = swatch.getAttribute('data-product-handle');
      var productUrl = swatch.getAttribute('data-product-url');
      if (!handle) return;

      event.preventDefault();
      event.stopPropagation();

      switchToProduct(handle, productUrl, { updateHistory: true });
    },
    true
  );

  window.addEventListener('popstate', function () {
    var handle = handleFromPath(window.location.pathname);
    if (!handle) return;

    var currentSection = getProductSection();
    if (currentSection && currentSection.getAttribute('data-product-handle') === handle) {
      return;
    }

    switchToProduct(handle, window.location.pathname + window.location.search, { updateHistory: false });
  });
})();
